/**
 * Design tokens for JS components (imported via the "@tailwind" alias).
 *
 * The Tailwind theme itself now lives in src/css/index.css (@theme block,
 * Tailwind v4 CSS-first config). This file only mirrors the values that
 * JS needs at runtime (breakpoints, colors) — keep the two in sync.
 * The shape matches the old tailwind.config.js so existing imports keep working.
 */

module.exports = {
  theme: {
    screens: {
      xxs: "400px", // for super small screens
      xs: "500px",
      sm: "700px", // bigger than most phones
      md: "850px",
      lg: "1024px",
      xl: "1750px", // larger than 15" macbook pro
      xxl: "2000px",
    },
    extend: {
      colors: {
        black: {
          DEFAULT: "#33363E",
        },
        "dark-gray": {
          DEFAULT: "#5C5E65",
        },
        blue: {
          DEFAULT: "#0B83FF",
        },
        "dark-blue": {
          DEFAULT: "#222C47",
        },
        red: {
          DEFAULT: "#EC2626",
        },
        "light-silver": {
          DEFAULT: "#aaa",
        },
        silver: {
          DEFAULT: "#999",
        },
        "light-gray": {
          DEFAULT: "#eee",
        },
        "near-white": {
          DEFAULT: "#f4f4f4",
        },
      },
    },
  },
};
